import React from "react";
import { ITransport, IDocument } from "dataModels/contract";
import {Row, Col } from "react-grid-system";
import moment from "moment";
import { DATE_FORMAT, DsLayout, FormMode } from "shared/constants";
//import SimpleTable from "components/SimpleTable";
//import { DSAccordion } from "@ds/ds-snam";
//import { createComponent } from "@lit/react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import DSDividers from "@ds/ds-snam/dist/components/dividers";
import DsHorizontalDivider from "components/DsHorizontalDivider";
import { Output, Table } from "@ds/ds-snam/react";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import TransportInfo from "./transportInfo";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
interface ITransportFormReviewProps {
    formData: ITransport
    formMode: FormMode
}

const TransportFormReview: React.FC<ITransportFormReviewProps> = (props): JSX.Element => {
    const { formData,formMode } = props;
    const { t } = useTranslation(['contract','app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const tableCols = (() => {
        //return ["Tipologia documento", "Nome file", "Data fine validità", ];
        //return t("contract.contractList.tableColumns", { ns: 'contract', returnObjects: true }) as string[];
        return t('transporter.transporterForm.sections.review.fileTable.tableColumns', { ns: 'contract', returnObjects: true }) as string[];
    })();

    const tableRows = formData.documents.map((contract: IDocument, index) => {
        if(contract.size!==0&&contract.content!==''&& index!==1){
        return (
            <tr key={uuidv4()}>
                <td>{contract.type}</td>
                <td>{contract.name}</td>
                <td>{contract.expire !== null ? parseDateForDS(moment.unix(contract.expire).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1) : ''}</td>
            </tr>
        )
        }
    });
    const getTableRows = (): ITableRow[] => {
                         let myRetArr: ITableRow[] = [];
                         for (let i = 0; i < formData.documents.length; i++) {
                            if(formData.documents[i].size!==0&&formData.documents[i].content!==''&& i!==1){
                             let tempObj: ITableRow = {
                                 tableCells: [
                                     { 
                                         type: "text", 
                                         text: formData.documents[i].type
                                     },
                                     { 
                                         type: "text", 
                                         text: formData.documents[i].name,
                                     },
                                     { 
                                         type: "text", 
                                         text: formData.documents[i].expire !== null ? parseDateForDS(moment.unix(formData.documents[i].expire as number).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1) : ''
                                     }
                                 ]
                             
                         }
                         myRetArr.push(tempObj);
                        }
                        }
                         return myRetArr;
                 };
const myTableConfig: ITableConfig = {
            ...getDSTableSharedElements(250),
            tableHeader: {
                
                tableCellsHeader: [
                    getTableCellsHeaderSimple(t('transporter.transporterForm.sections.review.fileTable.tableColumns.0', { ns: 'contract'}) as string,"col1","34%","left"),
                    getTableCellsHeaderSimple(t('transporter.transporterForm.sections.review.fileTable.tableColumns.1', { ns: 'contract'}) as string,"col2","33%","left"),
                    getTableCellsHeaderSimple(t('transporter.transporterForm.sections.review.fileTable.tableColumns.2', { ns: 'contract'}) as string,"col3","33%","left")
                ]
            },
            tableRows: getTableRows()
        };
    return (
        <>
            {/*<Row style={{ marginBottom: "12px" }}>
                <Col>
                
                    <div className="box" style={{height:'300px'}}>
                        <div className="boxTitle">
                            
                            {t('transporter.transporterForm.sections.review.title.0')}
                        </div>
                        
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.0')}
                                    outputText={formData.businessName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.1')}
                                    outputText={formData.vat}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                

                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.2')}
                                    outputText={formData.businessSecondName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                               

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.3')}
                                    outputText={formData.businessAddress+", "+formData.businessStreetNumber +" - "+ formData.businessCity +" "+formData.businessPostalCode+" ("+ formData.businessProvince+")"}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                               
                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.info.fields.8')}
                                    outputText={formData.businessState}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                
                                
                            </div>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div className="box" style={{height:'300px'}}>
                        <div className="boxTitle">
                           
                            {t('transporter.transporterForm.sections.contactPerson.title')}
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.0')}
                                    outputText={formData.firstName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                               

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.1')}
                                    outputText={formData.secondName}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                               
                            </div>
                        </div>
                        <div className="boxContent">
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.3')}
                                    outputText={formData.countryCode+' '+formData.phone}
                                    style={{marginBottom:'16px'}}
                                ></Output>  
                                

                            </div>
                            <div className="boxContentColumn">
                                <Output
                                    outputTitle={t('transporter.transporterForm.sections.contactPerson.fields.4')}
                                    outputText={formData.email}
                                    style={{marginBottom:'16px'}}
                                ></Output>  
                               
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>*/}
            <TransportInfo formData={formData}/>

            {formMode===FormMode.NEW &&
            <>
            
            <Row style={{ marginBottom: "12px",padding:'10px',width:'100%' }}>
                <p className="pageSubTitle" style={{/*marginBottom:'30px',*/fontWeight:'bold'}}>
                    {/*Documenti*/}
                    {t('transporter.transporterForm.sections.review.fileTable.title')}
                </p>
                {/*<div className="box" style={{height:'fit-content',width:'100%'}}>
                    <table id="simpleTable" style={{border:'1px solid red'}}>
                        <thead>
                            <tr>
                                {tableCols.map((col: string) => {
                                    return (
                                        <th key={uuidv4()} style={{ textAlign: "left",background: layoutMode===DsLayout.DARK_MODE?"#04122a":"white", paddingBottom:'10px' }}>
                                            {col}
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {tableRows}
                        </tbody>
                    </table>
                </div>*/}
                
                {/*<Accordion
                    accordion-ui-variant="box" 
                    accordion-title="Documenti" 
                    accordion-id="accordion" 
                    right-label=""
                    is-accordion-open={false}
                    style={{width:'100%',background:'',marginTop:'5%'}}
                    >
                        <div slot="content" style={{}}>
                        <div className="box" style={{height:'fit-content',width:'99%'}}>
                            <table id="simpleTable">
                                <thead>
                                    <tr>
                                        {tableCols.map((col: string) => {
                                            return (
                                                <th key={uuidv4()} style={{ textAlign: "left",background:'white', paddingBottom:'10px' }}>
                                                    {col}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRows}
                                </tbody>
                            </table>
                        </div>
                        </div>
                </Accordion>*/}
            </Row>
            </>
        }
        {formData.documents.length > 0 && formMode===FormMode.NEW &&
            <Table 
                tableConfig={myTableConfig} 
            />
        } 
        <DsHorizontalDivider/>
        </>
        
    )
}

export default TransportFormReview;

